import PropTypes from 'prop-types'
import styled from 'styled-components'

const circleSize = '32px'

const CircleButton = styled.div`
  color: #1e4564;
  background-color: #ced7db;
  border-radius: calc(${circleSize} / 2);
  padding: 10px;
  min-width: ${circleSize};
  height: ${circleSize};
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  user-select: none;
  font-size: 14px;
  line-height: 20px;

  &:hover {
    background-color: #78909c;
    color: white;
    cursor: pointer;
  }

  ${props =>
    props.active &&
    `
      background-color: #4DBCE9;
      color: white;
    `}

  ${props =>
    props.hidden &&
    `
      visibility: hidden;
      pointer-events: none;
    `}
`

CircleButton.propTypes = {
  active: PropTypes.bool,
  hidden: PropTypes.bool
}

export default CircleButton
